/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import MuiPhoneNumber from 'material-ui-phone-number'
import {getUserDetails} from '../PropertyUserApi'
import Swal from 'sweetalert2'

type PropsDataType = {
  property_account_uuid: string
  setShowEditUserModal: (showEditUserModal: string) => void
  showEditUserModal: string
}
const modalsRoot = document.getElementById('root-modals') || document.body

const initial_values = {
  accouont_holder_name: '',
  email_id: '',
  contact_number: '',
  property_account_type_name: '',
  property_share: 0,
  rental_share: 0,
}

const EditNewPropertyUser = ({
  property_account_uuid,
  setShowEditUserModal,
  showEditUserModal,
}: PropsDataType) => {
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false)
  const [initialValues, setInitialValues] = useState(initial_values)

  // Function to close the modal
  const handleClose = () => {
    setShowEditUserModal('')
  }

  // validations for edit users
  const validationSchema = Yup.object({
    accouont_holder_name: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Required'),
    email_id: Yup.string()
      .email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Required'),
    contact_number: Yup.string().required('Required'),
    property_account_type_name: Yup.string().required('Required'),
    property_share: Yup.number()
    .typeError('This field must be a number') 
    .max(100, 'The property share must not exceed 100')
    .required('This property share field is required'),
    rental_share: Yup.number()
    .typeError('This field must be a number')
    .max(100, 'The rental share must not exceed 100')
    .required('This rental share field is required'),
  })

  // formik object for edit user form
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })

  // submit function for edit user - for now its disabled as email and contact can not be changed
  const handleSubmit = async () => {}

  // Function to get the single user
  const getSingleUserDetails = async () => {
    try {
      const {data: user} = await getUserDetails(property_account_uuid)
      if (user.code === '200') {
        setInitialValues(user.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: user.msg.charAt(0).toUpperCase() + user.msg.slice(1),
          text: user.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // onload fetch single user
  useEffect(() => {
    getSingleUserDetails()
  }, [])

  console.log("initialValues", initialValues)

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={showEditUserModal ? true : false}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header pt-5 pb-5'>
        {/* begin::Heading */}
        <h2>Edit property user</h2>
        {/* end::Heading */}
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body p-5'>
        {/*begin::Form */}
        <form
          onSubmit={formik.handleSubmit}
          className='d-flex flex-column justify-content-center px-5'
        >
          {/*begin::Form Field Name */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>Name</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter name'
              ></i>
            </label>
            <input
              disabled
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter name'
              {...formik.getFieldProps('accouont_holder_name')}
              name='accouont_holder_name'
            />
            <div className='h-20px'>
              {formik.touched.accouont_holder_name && formik.errors.accouont_holder_name && (
                <div className='fv-help-block color-red'>{formik.errors.accouont_holder_name}</div>
              )}
            </div>
          </div>
          {/*end::Form Field Name */}
          {/*begin::Form Field Email ID */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>Email ID</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter email ID'
              ></i>
            </label>
            <input
              disabled
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter email ID'
              {...formik.getFieldProps('email_id')}
              name='email_id'
            />
            <div className='h-20px'>
              {formik.touched.email_id && formik.errors.email_id && (
                <div className='fv-help-block color-red'>{formik.errors.email_id}</div>
              )}
            </div>
          </div>
          {/*end::Form Field Email ID */}
          {/*begin::Form Field Contact number */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>Contact number</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter contact number'
              ></i>
            </label>
            <MuiPhoneNumber
              disabled
              {...formik.getFieldProps('contact_number')}
              className='w-100'
              defaultCountry={'in'}
              //   onChange={(value: string) => formik.setFieldValue('owner_contact_number', value)}
            />
            <div className='h-20px'>
              {formik.touched.contact_number && formik.errors.contact_number && (
                <div className='fv-help-block color-red'>{formik.errors.contact_number}</div>
              )}
            </div>
          </div>
          {/*end::Form Field Contact number */}

          {/*begin::Form Field Property Share */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>Property Share</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Property Share'
              ></i>
            </label>
            <input
              disabled
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter name'
              {...formik.getFieldProps('property_share')}
              name='property_share'
            />
            <div className='h-20px'>
              {formik.touched.property_share && formik.errors.property_share && (
                <div className='fv-help-block color-red'>{formik.errors.property_share}</div>
              )}
            </div>
          </div>
          {/*end::Form Field Property Share */}


          {/*begin::Form Field Rental Share */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>Rental Share</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Rental Share'
              ></i>
            </label>
            <input
              disabled
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter Rental Share'
              {...formik.getFieldProps('rental_share')}
              name='rental_share'
            />
            <div className='h-20px'>
              {formik.touched.rental_share && formik.errors.rental_share && (
                <div className='fv-help-block color-red'>{formik.errors.rental_share}</div>
              )}
            </div>
          </div>
          {/*end::Form Field Rental Share */}



          {/*begin::Form Field User Type */}
          <div className='fv-row'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className='required'>User Type</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Select user type'
              ></i>
            </label>
            <input
              disabled
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Select user type'
              {...formik.getFieldProps('property_account_type_name')}
              name='property_account_type_name'
            />
            <div className='h-20px'>
              {formik.touched.property_account_type_name &&
                formik.errors.property_account_type_name && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.property_account_type_name}
                  </div>
                )}
            </div>
          </div>
          {/*end::Form Field User Type */}

          {/*begin::Form Field Update button */}
          {/* <button
              type='submit'
              className='btn btn-lg btn-primary mx-auto'
              // data-kt-stepper-action='submit'
              // onClick={handleSubmit}
              disabled={submitBtnLoading}
            >
              {submitBtnLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Processing...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                'Update'
              )}
            </button> */}
          {/*end::Form Field Update button */}
        </form>
        {/*end::Form */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default EditNewPropertyUser
